import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import useTenantState from '@/states/tenant.state';
import useAuthState from '@/states/auth.state';
import { getSubscriptionEndDate } from '@/utils/subscription';
import { env } from '@/utils/constants/env';

export const SubscriptionExpiredOverlay = () => {
  const { currentTenant } = useTenantState();
  const { isSuperAdmin, token, loadUserProfile } = useAuthState();

  const endDateStr = isSuperAdmin ? null : getSubscriptionEndDate(currentTenant ?? undefined);

  // Re-read the subscription from /api/me whenever the window regains focus, so a
  // renewal or an admin reactivation done elsewhere unlocks the workspace without a reload.
  useEffect(() => {
    if (!endDateStr || !token) return;

    const refreshProfile = () => {
      loadUserProfile(token, true).catch(() => undefined);
    };

    window.addEventListener('focus', refreshProfile);
    return () => window.removeEventListener('focus', refreshProfile);
  }, [endDateStr, token, loadUserProfile]);

  if (!endDateStr) return null;

  const renewUrl = `${env.homePageUrl}/dashboard/${currentTenant?.uuid}/subscriptions`;

  return (
    <div className="flex items-center justify-center min-h-[70vh] w-full">
      <div className="text-center px-6 max-w-lg">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-100 mb-6">
          <AlertTriangle className="w-10 h-10 text-amber-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Langganan Berakhir</h2>
        <p className="text-base text-gray-600 mb-2">
          Langganan Anda telah berakhir {endDateStr}. Untuk terus menggunakan aplikasi, silakan perpanjang langganan
          Anda.
        </p>
        <p className="text-base text-gray-600 mb-6">Kami menantikan Anda kembali!</p>
        <a
          href={renewUrl}
          className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
        >
          Perpanjang Sekarang
        </a>
      </div>
    </div>
  );
};
